import styled from 'styled-components';

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
